import Swiper, {
    Navigation,
    Pagination
} from 'swiper';

export default class BtInstallationsSlider {

    slideClass = 'jet-listing-grid__item';

    wrapperClass = 'jet-listing-grid__items';

    swiperOptions = {
        modules: [
            Pagination,
            Navigation
        ],
        loop: true,
        slidesPerView: 1.5,
        centeredSlides: true,
        wrapperClass: 'swiper-wrapper',
        slideClass: 'swiper-slide',
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 4,
                spaceBetween: 16,
                centeredSlides: false,
                loop: false,
            }
        },
    };

    constructor() {
        this.addEvents();
    }

    addEvents() {
        const swiperElements = document.querySelectorAll('.bt-installations-slider .jet-listing-grid');


        if (!swiperElements) return;

        const that = this;
        window.addEventListener('load', e => {
            setTimeout(() => {
                swiperElements.forEach((swiperElement) => {
                    // init swiper
                    swiperElement.classList.add('swiper-container');
                    const swiperSlides = swiperElement.querySelectorAll(`.${this.slideClass}`);

                    if(swiperSlides.length > 4 || ( document.body.offsetWidth <= 768 && swiperSlides.length >= 2 ) ) {
                        let less_four = swiperSlides.length <= 4 ? 'swiper-hide' : '';
                        swiperElement.innerHTML += ('<div class="swiper-button-prev">' +
                            '<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0.86 0.01 19.39 16.97"><path d="M19.9375 8.91682L13.0597 16.5733C12.9528 16.6923 12.8235 16.789 12.6793 16.858C12.535 16.9271 12.3785 16.967 12.2188 16.9756C12.0591 16.9841 11.8993 16.9611 11.7485 16.9079C11.5976 16.8547 11.4588 16.7723 11.3398 16.6654C11.2208 16.5585 11.1241 16.4293 11.055 16.285C10.986 16.1407 10.9461 15.9843 10.9375 15.8246C10.929 15.6648 10.952 15.505 11.0052 15.3542C11.0584 15.2034 11.1408 15.0645 11.2477 14.9455L16.1774 9.47051L2.13972 10.2225C1.81849 10.2397 1.50358 10.1286 1.26427 9.91366C1.02496 9.69869 0.880851 9.39745 0.863642 9.07622C0.846434 8.75499 0.957537 8.44009 1.17251 8.20078C1.38749 7.96147 1.68872 7.81735 2.00995 7.80015L16.0477 7.04813L10.5612 2.13112C10.3209 1.91527 10.1762 1.6128 10.1589 1.29026C10.1416 0.967715 10.2532 0.651519 10.469 0.411229C10.6849 0.170939 10.9874 0.0262383 11.3099 0.00895922C11.6324 -0.00831982 11.9486 0.103238 12.1889 0.319092L19.8454 7.19693C19.9649 7.30344 20.0622 7.43258 20.1316 7.57688C20.201 7.72118 20.2412 7.87779 20.2497 8.03768C20.2583 8.19757 20.2351 8.35758 20.1815 8.50847C20.128 8.65936 20.045 8.79814 19.9375 8.91682V8.91682Z" fill="#262626"></path></svg></div> ' +
                            '<div class="swiper-button-next"> ' +
                            '<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0.86 0.01 19.39 16.97"><path d="M19.9375 8.91682L13.0597 16.5733C12.9528 16.6923 12.8235 16.789 12.6793 16.858C12.535 16.9271 12.3785 16.967 12.2188 16.9756C12.0591 16.9841 11.8993 16.9611 11.7485 16.9079C11.5976 16.8547 11.4588 16.7723 11.3398 16.6654C11.2208 16.5585 11.1241 16.4293 11.055 16.285C10.986 16.1407 10.9461 15.9843 10.9375 15.8246C10.929 15.6648 10.952 15.505 11.0052 15.3542C11.0584 15.2034 11.1408 15.0645 11.2477 14.9455L16.1774 9.47051L2.13972 10.2225C1.81849 10.2397 1.50358 10.1286 1.26427 9.91366C1.02496 9.69869 0.880851 9.39745 0.863642 9.07622C0.846434 8.75499 0.957537 8.44009 1.17251 8.20078C1.38749 7.96147 1.68872 7.81735 2.00995 7.80015L16.0477 7.04813L10.5612 2.13112C10.3209 1.91527 10.1762 1.6128 10.1589 1.29026C10.1416 0.967715 10.2532 0.651519 10.469 0.411229C10.6849 0.170939 10.9874 0.0262383 11.3099 0.00895922C11.6324 -0.00831982 11.9486 0.103238 12.1889 0.319092L19.8454 7.19693C19.9649 7.30344 20.0622 7.43258 20.1316 7.57688C20.201 7.72118 20.2412 7.87779 20.2497 8.03768C20.2583 8.19757 20.2351 8.35758 20.1815 8.50847C20.128 8.65936 20.045 8.79814 19.9375 8.91682V8.91682Z" fill="#262626"></path></svg> </div> ' +
                            '<div class="swiper-pagination relative '+less_four+'"></div>');
                    }
                    const swiperWrapper = swiperElement.querySelector(`.${this.wrapperClass}`);
                    swiperWrapper.setAttribute('class', 'swiper-wrapper');

                    if(swiperSlides.length > 4 || ( document.body.offsetWidth <= 768 && swiperSlides.length >= 2 ) ) {
                        swiperWrapper.querySelectorAll(`.${this.slideClass}`).forEach((el) => {
                            el.setAttribute('class', 'swiper-slide');
                        });
                        new Swiper(swiperElement, this.swiperOptions);
                    }
                });
            }, 500)
        });
    }
}
